import React from 'react';
import PropTypes from 'prop-types';
import Forbidden from './Forbidden';
import BackToHomeButton from '../UI/Actions/BackToHomeButton';
import { Translate } from '@above-the-treeline/localization';

export const ErrorTypes = {
	forbidden: 'forbidden',
	unauthorized: 'unauthorized',
};

export default class ErrorBoundary extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.element,
			PropTypes.arrayOf(PropTypes.element),
		]).isRequired,
		FallbackComponent: PropTypes.element, // not required
		doLocalize: PropTypes.bool,
	};

	state = { hasError: false, error: null };

	render() {
		const { FallbackComponent: Fallback } = this.props;

		if (this.hasForbiddenError()) {
			const msg = this.state.error ? this.state.error.message : '';
			return <Forbidden errorMessage={msg} />;
		}

		if (this.state.hasError) {
			// Render any custom fallback UI
			return Fallback ? <Fallback /> : this.defaultFallback();
		}

		return this.props.children;
	}

	// Update state so the next render will show the fallback UI.
	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	// Log the error to an error reporting service
	componentDidCatch(error, info) {
		console.error(error, info);
	}

	hasForbiddenError() {
		return (
			this.state.error && this.state.error.type === ErrorTypes.forbidden
		);
	}

	defaultFallback() {
		const rootStyle = {
			paddingTop: '5rem',
			paddingLeft: '2rem',
			height: '100vh',
		};

		return (
			<div style={rootStyle}>
				<h3>
					{this.props.doLocalize ? (
						<Translate id="error_boundary_default_fallback_message" />
					) : (
						'Sorry, something went wrong.'
					)}
				</h3>
				<div style={{ paddingTop: '1rem' }}>
					<BackToHomeButton />
				</div>
			</div>
		);
	}
}

ErrorBoundary.defaultProps = {
	doLocalize: true,
};
